// Module
var code = "";
// Exports
var _module_exports = code;;
var path = 'app/common/ui/actionTabs/templates/actionTabs.horizontal.tpl.html';
window.angular.module('app').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;